module.exports = __webpack_public_path__ + "img/configicon.df674788.svg";